import { useNavigate } from "react-router";
import PageMeta from "../../../components/common/PageMeta";
import PageBreadcrumb from "../../../components/common/PageBreadCrumb";
import NewDomainForm from "../../../components/apps/domains/NewDomainForm";

export default function NewDomain() {
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/apps/domains`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Domínio"
                description="Criar novo domínio"
            />
            <PageBreadcrumb
                pageTitle="Novo Domínio"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewDomainForm
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de webhooks
                        navigate(`/apps/domains`);
                    }}
                    onError={(error: any) => {
                        console.error("Erro ao criar domínio:", error);
                    }}
                />
            </div>
        </>
    );
}